import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "../reducers/common/index";
import authenticationSlice from "../reducers/auth/index";
import accessManagementSlice from "../reducers/AccessManagement/index";

import parents from "src/reducers/parents";
import captains from "src/reducers/captains";
import cameras from "src/reducers/cameras";
import bookings from "src/reducers/bookings";
import routes from "src/reducers/routes";
import schools from "src/reducers/schools";
import dashboard from "src/reducers/dashboard";


export const store = configureStore({
  reducer: {
    common: commonSlice,
    auth: authenticationSlice,
    accessManagement: accessManagementSlice,
    parents,
    captains,
    cameras,
    bookings,
    routes,
    schools,
    dashboard
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;